exports.shouldUpdate = (record, nextRecord) => {

    return (record.id !== nextRecord.id) ||
        (new Date(record.updatedAt || 0) < new Date(nextRecord.updatedAt || 0));
};
